/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { SimpleTable } from '../../../../components/SimpleTable';
import { colors } from '../../../../utils/colors';
import {
  getTwoDecimal,
  translateStyleTilts,
  translateText,
} from '../../../../utils/helpers';
import { translation } from '../../../Translation/scorecard';

function EquityTable({ data, language }) {
  const french = language === 'fr';
  return (
    <TableWrapper>
      <SimpleTable>
        <thead>
          <tr>
            <th>{translation[language].EQUITYSTYLE_TABLE.header1}</th>
            <th>{translation[language].EQUITYSTYLE_TABLE.header2}</th>
            <th style={{ width: '40%' }}>
              {translation[language].EQUITYSTYLE_TABLE.header3}
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(data).map((factor) => (
            <tr key={factor}>
              <td>{translateText(factor, french)}</td>
              <td>{data[factor] === 0 ? '-' : getTwoDecimal(data[factor])}</td>
              <td>
                <div className="chip-background">
                  <div className={`option ${data[factor] < 0 && 'selected'}`}>
                    {translateStyleTilts(factor, 'negative', french)}
                  </div>
                  <div className={`option ${data[factor] === 0 && 'neutral'}`}>
                    {translateStyleTilts(factor, 'neutral', french)}
                  </div>
                  <div className={`option ${data[factor] > 0 && 'selected'}`}>
                    {translateStyleTilts(factor, 'positive', french)}
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </SimpleTable>
    </TableWrapper>
  );
}

export default connect((state) => ({
  language: state.Storage.language,
}))(EquityTable);

EquityTable.propTypes = {
  data: PropTypes.array.isRequired,
  language: PropTypes.string,
};

EquityTable.defaultProps = {
  language: 'en',
};

const TableWrapper = styled.div`
  width: 80%;
  table {
    color: black !important;
  }
  thead {
    border-top: 1px solid ${colors.lightGrey};
  }

  th:first-child {
    border-right: 1px solid ${colors.lightGrey};
  }

  td:first-child {
    border-right: 1px solid ${colors.lightGrey} !important;
  }

  .chip-background {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${colors.lightGrey};
    border-radius: 15px;
    min-width: 330px;

    .option {
      width: 33%;
    }
    .selected {
      background-color: ${colors.teal};
      border-radius: 15px;
      padding: 5px 10px 5px 10px;
      font-weight: bold;
    }
    .neutral {
      background-color: ${colors.grey};
      border-radius: 15px;
      padding: 5px 10px 5px 10px;
      font-weight: bold;
    }
  }

  .tilt {
    display: flex;
    direction: row;
    justify-content: center;
  }
`;
